"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhiteSpaceRegex = exports.Denominators = exports.AnswerConditionContext = void 0;
var questionnaire_condition_context_1 = require("./questionnaire-condition-context");
var AnswerConditionContext = /** @class */ (function () {
    function AnswerConditionContext(questionId, valueType, denominator) {
        this.questionId = questionId;
        this.contextType = questionnaire_condition_context_1.QuestionnaireConditionContext.Answer;
        this.valueType = valueType;
        this.denominator = denominator;
    }
    return AnswerConditionContext;
}());
exports.AnswerConditionContext = AnswerConditionContext;
var Denominators;
(function (Denominators) {
    Denominators["Empty"] = "";
    Denominators["Whitespace"] = " ";
})(Denominators = exports.Denominators || (exports.Denominators = {}));
exports.WhiteSpaceRegex = /\s+/;
